/// <amd-module name="typeahead/features/WrapSuggestionText" />
import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {SuggestionShownMessage} from "typeahead/core/message/SuggestionShownMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        experiment: {
            id: 24828,
            name: "ESS_WRAP_TA_DISPLAY_HOTEL",
            value: 1,
        },
        lobs: ["HOTELS"],
    },
    {
        experiment: {
            id: 24829,
            name: "ESS_WRAP_DISPLAY_NAME_CARS",
            value: 1,
        },
        lobs: ["CARS"],
    },
    {
        experiment: {
            id: 24830,
            name: "ESS_WRAP_DISPLAY_NAME_FLIGHTS",
            value: 1,
        },
        lobs: ["FLIGHTS"],
    },
];

export class WrapSuggestionText implements IExperimentalFeature, IPageLoadHandler {

    private static css = `
        div.autocomplete-dropdown ul.results a.details {white-space: normal !important;}
        div.autocomplete-dropdown ul.results a.details .icon {float: left;}
        div.autocomplete-dropdown ul.results a.details .text {display:block; overflow:hidden;}
        div.autocomplete-dropdown .results-item.list-item > a.details > .text { float:left; } 
    `;

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public handlePageLoad(options: any, context: IContext): void {
        TypeaheadMessage.subscribe(SuggestionShownMessage.getTopic(),
            (topic: string, message: SuggestionShownMessage) => {
            let $ulElement = $("div.autocomplete-dropdown:visible ul.results");
            context.lob = message.getLob();
            if (!$ulElement.children("style#wrap-suggestion-text").length // style not already attached
                && this.isTextOverflowing()
                && ExecutionHelper.shouldExecute(context, configuration)) {
                let style = document.createElement("style");
                style.id = "wrap-suggestion-text";
                style.type = "text/css";
                style.innerHTML = WrapSuggestionText.css;
                $ulElement.append(style);
            }
        });
    }

    private isTextOverflowing(): boolean {
        let $resultItems = $("div.autocomplete-dropdown:visible a.details");
        if ($resultItems.length) {
            let innerWidth: number = $resultItems.innerWidth();
            for (let i: number = 0; i < $resultItems.length; i++) {
                if ($resultItems[i].scrollWidth > innerWidth) {
                    return true;
                }
            }
        }
        return false;
    }
}
